module.exports = __webpack_public_path__ + "img/arrow_down.c21803be.png";